import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { ChartPlaceholder } from "@/components/primitives/ChartPlaceholder";
import { Callout } from "@/components/primitives/Callout";

/**
 * 02 · ResearchSlide
 *
 * Designed for HAEVN Labs / research-style chapters. Headline + narrative on
 * the left, a large data visualization on the right, with a supporting
 * callout and a quiet source attribution at the bottom.
 */
export const ResearchSlide = ({
  eyebrow = "HAEVN Labs",
  title = "A finding, framed.",
  narrative = "Two or three sentences that summarize the underlying research without overwhelming the chart. Keep the language plain.",
  chartVariant = "line",
  calloutTitle = "Why it matters",
  calloutBody = "One sentence that translates the data into a meaningful implication.",
  source = "Source · Placeholder Study, 2026",
}) => {
  return (
    <SlideFrame testId="slide-research">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="flex flex-col gap-6 lg:col-span-5">
          <SlideHeader eyebrow={eyebrow} title={title} lede={narrative} />
        </div>
        <div className="flex flex-col gap-6 lg:col-span-7">
          <Reveal delay={2}>
            <ChartPlaceholder variant={chartVariant} testId="research-chart" />
          </Reveal>
          <Reveal delay={3}>
            <Callout variant="info" title={calloutTitle} testId="research-callout">
              {calloutBody}
            </Callout>
          </Reveal>
        </div>
      </div>
      <Reveal delay={4}>
        <div
          data-testid="research-source"
          className="border-t border-border pt-4 text-xs text-muted-foreground"
        >
          {source}
        </div>
      </Reveal>
    </SlideFrame>
  );
};

export default ResearchSlide;
